import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumbs = ({ items = [] }) => {
  const navigate = useNavigate();

  if (!items || items?.length === 0) {
    return null;
  }

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <div className="breadcrumbs">
      <div className="breadcrumbs-container">
        <nav aria-label="Breadcrumb">
          <ol className="breadcrumbs-list">
            {items?.map((item, index) => {
              const isLast = index === items?.length - 1;
              
              return (
                <li key={index} className="breadcrumbs-item">
                  {!isLast ? (
                    <>
                      <button
                        onClick={() => handleNavigation(item?.path)}
                        className="breadcrumbs-link"
                      >
                        {item?.icon && (
                          <Icon name={item?.icon} size={16} className="mr-1" />
                        )}
                        {item?.label}
                      </button>
                      <Icon 
                        name="ChevronRight" 
                        size={16} 
                        className="breadcrumbs-separator" 
                      />
                    </>
                  ) : (
                    <span className="breadcrumbs-current">
                      {item?.icon && (
                        <Icon name={item?.icon} size={16} className="mr-1" />
                      )}
                      {item?.label}
                    </span>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default Breadcrumbs;